(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-bleed-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeBleedNavigation = (root) => {
    if (root.dataset.navigationReady === 'true') return;

    const navigation = root.querySelector('[data-gb-bleed-nav]');
    if (!navigation) return;

    const updateNavigation = () => {
      navigation.classList.toggle('is-scrolled', window.scrollY > 24);
    };

    root.dataset.navigationReady = 'true';
    updateNavigation();
    window.addEventListener('scroll', updateNavigation, { passive: true });

    root.querySelectorAll('.gb-bleed__mobile-panel a').forEach((link) => {
      link.addEventListener('click', () => {
        const menu = link.closest('details');
        if (menu) menu.removeAttribute('open');
      });
    });
  };

  document.querySelectorAll('[data-gb-bleed-root]').forEach(initializeBleedNavigation);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-gb-bleed-root]').forEach(initializeBleedNavigation);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-home-editorial-v2"]) return;
  try {
    
(function(){
  function initGlassButterHome(root){
    if(!root||root.dataset.heroMotionReady)return;
    root.dataset.heroMotionReady='true';
    var nav=root.querySelector('.gb3-nav');
    var hero=root.querySelector('.gb3-hero');
    var heroVideo=root.querySelector('.gb3-hero__video');
    if(!nav||!hero)return;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    var queued=false;
    function update(){
      queued=false;
      var y=window.scrollY||document.documentElement.scrollTop||0;
      nav.classList.toggle('gb3-nav--scrolled',y>28);
      if(reduced.matches){
        root.style.removeProperty('--gb3-hero-shift');
        return;
      }
      var shift=Math.min(y*.08,56);
      root.style.setProperty('--gb3-hero-shift',shift+'px');
    }
    function requestUpdate(){
      if(queued)return;
      queued=true;
      window.requestAnimationFrame(update);
    }
    function syncVideoMotion(){
      if(!heroVideo)return;
      if(reduced.matches){
        heroVideo.pause();
        heroVideo.currentTime=0;
        return;
      }
      var playRequest=heroVideo.play();
      if(playRequest)playRequest.catch(function(){});
    }
    window.addEventListener('scroll',requestUpdate,{passive:true});
    reduced.addEventListener('change',function(){update();syncVideoMotion()});
    update();
    syncVideoMotion();
    root.querySelectorAll('[data-gb3-video-toggle]').forEach(function(button){
      var section=button.closest('.gb3-monthly');
      var video=section&&section.querySelector('.gb3-monthly__video');
      var label=button.querySelector('[data-gb3-video-toggle-label]');
      if(!video||!label)return;
      function renderVideoState(){
        var paused=video.paused;
        button.setAttribute('aria-pressed',paused?'true':'false');
        label.textContent=paused?button.dataset.playLabel:button.dataset.pauseLabel;
      }
      button.addEventListener('click',function(){
        if(video.paused){
          var request=video.play();
          if(request)request.catch(function(){});
        }else{
          video.pause();
        }
        window.setTimeout(renderVideoState,0);
      });
      video.addEventListener('play',renderVideoState);
      video.addEventListener('pause',renderVideoState);
      if(reduced.matches)video.pause();
      renderVideoState();
    });
  }
  document.querySelectorAll('.gb3').forEach(initGlassButterHome);
  document.addEventListener('shopify:section:load',function(event){
    var root=event.target.querySelector('.gb3');
    initGlassButterHome(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
